import { useMemo } from "react";
import { createApplicationService } from "./base/applicationServiceBase";
import { API } from "api/axios.config";

const FIXED_FEE_HEADERS_BASE = "/Bill/FixedFeeHeaders";

const fetchFixedFeeHeadersAPI = () => API.get(`${FIXED_FEE_HEADERS_BASE}`);

const addNewFixedFeeHeaderAPI = (data) =>
  API.post(`${FIXED_FEE_HEADERS_BASE}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });

const updateFixedFeeHeaderAPI = (id, data) =>
  API.patch(`${FIXED_FEE_HEADERS_BASE}/${id}`, JSON.stringify({ data }), {
    headers: { "Content-Type": "application/json" },
  });
const getFeeHeaderItemsAPI = (id) => API.get(`/Bill/FixedFeeItems/${id}`);
const addFeeHeaderItemsAPI = (id, data) => API.post(`/Bill/FixedFeeItems/${id}`, JSON.stringify({ data }), {
  headers: { "Content-Type": "application/json" },
});
const editFeeHeaderItemsAPI = (id, data) => API.put(`/Bill/FixedFeeItems/${id}`, JSON.stringify({ data }), {
  headers: { "Content-Type": "application/json" },
});

const getActiveFeeItemsAPI = (id) => API.get(`/Bill/FixedFeeItems/${id}?active=true`);

const baseService = createApplicationService({
  name: "fixedFee",
  apiFetchFn: fetchFixedFeeHeadersAPI,
  apiAddFn: addNewFixedFeeHeaderAPI,
  apiUpdateFn: updateFixedFeeHeaderAPI,
});

const fixedFeeHeaderReducer = baseService.reducer;
const getFixedFeeHeaders = baseService.getData;
const addFixedFeeHeader = baseService.addData;
const updateFixedFeeHeader = baseService.updateData;
const useFixedFeeHeaders = baseService.useData;

const useActiveFeeHeaders = () => {
  const { data, loading } = useFixedFeeHeaders();
  const activeFeeHeaders = useMemo(() => data.filter((header) => header.active), [data]);
  return { data: activeFeeHeaders, loading };
};

export {
  fixedFeeHeaderReducer,
  getFixedFeeHeaders,
  addFixedFeeHeader,
  updateFixedFeeHeader,
  useFixedFeeHeaders,
  getFeeHeaderItemsAPI,
  addFeeHeaderItemsAPI,
  editFeeHeaderItemsAPI,
  useActiveFeeHeaders,
  getActiveFeeItemsAPI
};
